import { IAddress } from '@r1-frontend/shared/types/IAddress';

export enum EAvailableSpeed {
    lessOrEqual100 = 1,
    between100and1000 = 2, // range between 100 and 1000
    more1000 = 3, // more than 1000
}

export enum EVerificationStatus {
    notVerified = 'not verified',
    verifying = 'verifying',
    verified = 'verified',
    error = 'error', // HTTP 500
}

export interface IVerifiedAddressData {
    address: IAddress | null,
    gigabitAvail: number,
    isPrivate: number, // remove... the isHouseCottage do the same things
    isHouseConnected: boolean,
    status: EVerificationStatus,
    companyId: number,
    availableSpeed: EAvailableSpeed,
    isHouseCottage: boolean,
    error?: string,
}

export interface IContactAddress {
    isAgree: boolean,
    isEdit: boolean,
    editedAddressData: IAddress | null,
    verifiedAddressData: IVerifiedAddressData,
    wasCheckCalled: boolean,
}

export const initialState: IContactAddress = {
    isAgree: true,
    isEdit: true,
    editedAddressData: null,
    verifiedAddressData: {
        address: null,
        gigabitAvail: 0,
        isPrivate: 0,
        isHouseConnected: false,
        companyId: 0,
        status: EVerificationStatus.notVerified,
        availableSpeed: EAvailableSpeed.between100and1000,
        isHouseCottage: false,
    },
    wasCheckCalled: false,
};

export interface IContactAddressState {
    contactAddress: IContactAddress,
}
